import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useLanguagePreference } from "@/features/shell/hooks/useLanguagePreference";
import { cn } from "@/lib/utils";
import type { SupportedLocale } from "@/types/auth";

const LOCALES: { code: SupportedLocale; flag: string; label: string }[] = [
  { code: "en", flag: "🇬🇧", label: "English" },
  { code: "es", flag: "🇪🇸", label: "Español" },
  { code: "pt", flag: "🇧🇷", label: "Português" },
];

export function LanguageSwitcher() {
  const { language, changeLanguage } = useLanguagePreference();
  const current = LOCALES.find((l) => l.code === language) ?? LOCALES[1];

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          aria-label="Change language"
          className="flex h-8 w-8 items-center justify-center rounded-full border border-ink/10 bg-white/75 text-base shadow-sm transition hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {current.flag}
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="start"
          sideOffset={8}
          className="z-50 min-w-40 rounded-[1.5rem] border border-ink/10 bg-[#fffdf9] p-2 shadow-panel"
        >
          {LOCALES.map((locale) => (
            <DropdownMenu.Item
              key={locale.code}
              onSelect={() => changeLanguage(locale.code)}
              className={cn(
                "flex cursor-pointer items-center gap-2.5 rounded-[1.1rem] px-4 py-2.5 text-sm text-ink outline-none transition hover:bg-ink/5 focus:bg-ink/5",
                locale.code === language && "bg-ink/5 font-semibold",
              )}
            >
              <span className="text-base">{locale.flag}</span>
              <span>{locale.label}</span>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
